import { render } from "./QuizWelcome.vue?vue&type=template&id=7e7fd91a&scoped=true"
import script from "./QuizWelcome.vue?vue&type=script&lang=js"
export * from "./QuizWelcome.vue?vue&type=script&lang=js"

import "./QuizWelcome.vue?vue&type=style&index=0&id=7e7fd91a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7fd91a"]])

export default __exports__